import React from "react";

function BusinessContactDetails({
  businessContactNo,
  setBusinessContactNo,

  alternateContactNo,
  setAlternateContactNo,

  sameAsPersonal,
  setSameAsPersonal,

  businessEmail,
  setBusinessEmail,

  website,
  setWebsite,
}) {
  return (
    <div className="Business-container mt-4">
      <h2>Contact Details</h2>

      <div className="contact-row">
        <div className="field half">
          <label>Business contact no</label>

          <input
            type="text"
            placeholder="Enter business contact no"
            value={businessContactNo}
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setBusinessContactNo(value);
            }}
          />
        </div>

        <div className="field half">
          <label>Alternative Business contact no</label>

          <input
            type="text"
            placeholder="Enter alternative contact no"
            value={alternateContactNo}
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setAlternateContactNo(value);
            }}
          />
        </div>
      </div>

      {/* <div className="checkbox-row">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            checked={sameAsPersonal}
            onChange={() => setSameAsPersonal(!sameAsPersonal)}
          />
          <span className="checkmark"></span>

          <span className="checkbox-text">Same as your personal contact</span>
        </label>
      </div> */}

      <div className="field">
        <label>Business email</label>

        <input
          type="email"
          placeholder="Enter business email"
          value={businessEmail}
          onChange={(e) => setBusinessEmail(e.target.value)}
        />
      </div>

      <div className="field">
        <label>Official website (optional)</label>

        <input
          type="text"
          placeholder="https://example.com"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
        />
      </div>
    </div>
  );
}

export default BusinessContactDetails;
